(function () {
  'use strict';

  angular
    .module('appback')
    .controller('PreanaliticaController', PreanaliticaController)

  PreanaliticaController.$inject = ["socket", "ResultadosService", "GenerallabService", "PreanaliticaService", "$http", "$timeout", "$uibModal", "$log", "$document", "$sce", "Upload"];

  function PreanaliticaController(socket, ResultadosService, GenerallabService, PreanaliticaService, $http, $timeout, $uibModal, $log, $document, $sce, Upload) {
    var vm = this;
    vm.loading = false;
    vm.grid = "";
    vm.connectedRoom = false;
    vm.connectedUsers = 0;
    vm.printService = new WebSocketPrinter();

    if (typeof (io) !== 'undefined') {
      vm.socketMaquinas = io.connect('https://maquinas.uranovet.com:4001/', {
        transports: ['websocket'],
        secure: true
      });

      vm.socketMaquinas.on('connect', function () {
        var storedRoom = localStorage.getItem('preanalitica_room');
        var storedTime = localStorage.getItem('preanalitica_date');
        var now = Date.now();
        var oneDay = 24 * 60 * 60 * 1000; // 24 hours

        if (storedRoom && storedTime && (now - storedTime < oneDay)) {
          vm.timestamp = parseInt(storedRoom);
        } else {
          vm.timestamp = now;
          localStorage.setItem('preanalitica_room', vm.timestamp);
          localStorage.setItem('preanalitica_date', now);
        }
        console.log("stored time", storedTime);
        console.log("stored room", storedRoom);
        console.log("timestamp", vm.timestamp);
        //vm.timestamp = Date.now();

        vm.socketMaquinas.emit('preanalitica:join', { room: vm.timestamp, isOwner: true });
        console.log('Conectado a socket de maquinas.uranovet.com:4001');
        // Generate QR Code
        $timeout(function () {
          var qrcodeContainer = document.getElementById("qrcode");
          if (qrcodeContainer) {
            qrcodeContainer.innerHTML = ""; // Clear previous code if any
            new QRCode(qrcodeContainer, {
              text: vm.timestamp.toString(),
              width: 100,
              height: 100,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H
            });
            vm.connectedRoom = true;
          }
        }, 500); // Wait for DOM to be ready
      });

      vm.socketMaquinas.on('preanalitica:foto-sobre', function (data) {
        console.log('fotosobre recibida', data);
        if(data.code){
          vm.getMuestras(data.code);
        }else{
          vm.sendFotoSobre(data.image, true);
        }
      });

      vm.socketMaquinas.on('preanalitica:closeprint', function (data) {
        console.log('closeprint recibida', data);
        vm.modalOK.close();
      });

      vm.socketMaquinas.on('preanalitica:doprint', function (data) {
        console.log('doprint recibida', data);
        vm.printRaw(data.print);
      });

      vm.socketMaquinas.on('preanalitica:users_update', function (data) {
        console.log('Usuarios conectados:', data);
        $timeout(function () {
          vm.connectedUsers = data.count - 1;
        });
      });

      vm.socketMaquinas.on('disconnect', function () {
        vm.connectedRoom = false;
        console.log('Desconectado de socket de maquinas.uranovet.com:4001');
      });

      vm.socketMaquinas.on('error', function (error) {
        vm.connectedRoom = false;
        console.error('Error en socket de maquinas:', error);
      });
    } else {
      console.warn('Socket.io no estÃ¡ disponible');
    }

    vm.sendFotoSobre = function (data, base64) {
      Upload.upload({
        url: '/backend/preanalitica/getidfromimage',
        data: { file: data, base64: base64 }
      }).then(function (resp) {
        console.log('Response upload foto: ', resp);
        if (resp.data.codeP > 0) {
          vm.getMuestras(resp.data.codeP);
        } else {
          vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: false, read_code: 0 });
          ////vm.abrirCamara();
        }
      }, function (resp) {
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        //console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
      });
    }

    vm.printRaw = function (value) {
      vm.printService.submit({
        'type': 'INVOICE',
        'raw_content': value
      });
    };
    /*
    ^XA
    ^FX Third section with barcode.
    ^FO44,30
    ^BY1
    ^BC,100,Y,N,N,A
    ^FD200929001^FS
    ^FO 181,30
    ^BY1
    ^BC,100,Y,N,N,A
    ^FD200929002^FS
    ^FO 318,30
    ^BY1
    ^BC,100,Y,N,N,A
    ^FD200929003^FS
    ^FO 455,30
    ^BY1
    ^BC,100,Y,N,N,A
    ^FD200929004^FS
    ^XZ*/
    vm.init = function () {
      //$.pjax.reload({container:'#w0'});
    };


    vm.filtrar = function () {
      $('[name="ViewEncaminoSearch[lims_id]"]').val(vm.lims_id);
      //$.fn.yiiGridView.update('#w0');
      //$('#w0').yiiGridView('applyFilter');
      $.pjax.reload('#pjax-grid-view', { timeout: 1000 });

    };
    vm.cambiarPendiente = function (lims_id) {
      PreanaliticaService.cambiarPendiente(lims_id, function (data) {
        if (data.carta.length > 0) {
          //console.log("EMIT nueva carta");
          for (var cont = 0; cont < data.carta.length; cont++) {
            socket.emit('pizarra:nuevacarta', { carta: data.carta[cont] });
          }
        }
        $.pjax.reload('#pjax-grid-view', { timeout: 1000 });
      });
    };

    function format(icon) {
      var originalOption = icon.element;
      var str = "";
      if (typeof $(originalOption).data('icon') != 'undefined') {
        str += '<i class="icon alt' + $(originalOption).data('icon') + '"></i> <span>' + icon.text + '</span>';
        return $(str + " ");
      } else {
        return icon.text || icon.value;
      }
    }

    vm.optionsTiposMuestra = {
      ajax: {
        url: "/backend/altcrm/content/select2",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term, // search term
            page: params.page,
            field: 'nombre',
            per_page: 20,
            nodetype: 'tipomuestra'
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.items,
            pagination: {
              more: (params.page * 1) < data.total_count
            }
          };
        },
        cache: true
      },
      templateSelection: format,
      templateResult: format
    };

    vm.optionsEstadomuestra = {
      ajax: {
        url: "/backend/altcrm/content/select2",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term, // search term
            page: params.page,
            field: 'nombre',
            per_page: 20,
            nodetype: 'estadomuestra'
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.items,
            pagination: {
              more: (params.page * 1) < data.total_count
            }
          };
        },
        cache: true
      },
      templateSelection: format,
      templateResult: format
    };

    vm.optionsTipotubo = {
      ajax: {
        url: "/backend/altcrm/content/select2",
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term, // search term
            page: params.page,
            field: 'nombre',
            per_page: 20,
            nodetype: 'tipotubo'
          };
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.items,
            pagination: {
              more: (params.page * 1) < data.total_count
            }
          };
        },
        cache: true
      },
      templateSelection: format,
      templateResult: format
    };

    vm.modalPeticion = "";
    vm.modalOK = "";
    vm.modalInfoLlegada = "";
    vm.modalEnvioAlic = "";

    vm.enviarAlic = function (peticion_id) {
      PreanaliticaService.getAlic(peticion_id, function (data) {
        vm.modalEnvioAlic = $uibModal.open({
          animation: true,
          ariaLabelledBy: 'modal-title-top',
          ariaDescribedBy: 'modal-body-top',
          templateUrl: 'enviosalic.html',
          size: 'lg',
          backdrop: 'static',
          controller: function ($scope) {
            $scope.generalLab = GenerallabService;
            $scope.data = data;
            $scope.muestrasEstados = data.muestrasEstados;
            $scope.peticion_id = peticion_id;
            $scope.disabled = false;

            $scope.existeTipo = function (tipo) {
              var res = false;
              for (var cont = 0; cont < $scope.muestrasEstados.length && !res; cont++) {
                if ($scope.muestrasEstados[cont].tipomuestra_id == tipo.id && $scope.muestrasEstados[cont].active == 1) {
                  res = true;
                }
              }
              return res;
            }

            $scope.okForm = function () {
              $scope.disabled = true;
              PreanaliticaService.saveAlic($scope, function () {
                location.reload();
              })
            }

            $scope.koForm = function () {
              vm.modalEnvioAlic.close();
            };
          }
        });
      });
    }

    vm.getLLegada = function () {
      PreanaliticaService.getLlegada(vm.lims_id, function (data) {
        if (data.peticion) {
          vm.modalInfoLlegada = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-top',
            ariaDescribedBy: 'modal-body-top',
            templateUrl: 'peticionInfo.html',
            size: 'lg',
            backdrop: 'static',
            controller: function ($scope) {
              $scope.peticion = data.peticion;
              $scope.analiticas = data.analiticasPeticion;
              $scope.generalLab = GenerallabService;
              $scope.muestrasEstados = data.muestrasEstados;
              $scope.muestrasEnviadas = data.muestrasEnviadas;
              $scope.printRaw = function () {
                //vm.printRaw(data.print);
              }

              $scope.okForm = function () {
                $scope.disabled = true;
                PreanaliticaService.marcarLLegada($scope.laboratorio_id, $scope.peticion[0].id, $scope, function (dataLlegada) {
                  if (dataLlegada.code == 10) {
                    vm.modalInfoLlegada.close();
                    vm.lims_id = "";
                    $scope.muestrasEstados = dataLlegada.muestrasEstados;
                  } else {
                    alert("ERROR FATAL (VUELVE A PROBAR).");
                  }
                  $scope.disabled = false;

                });
              }

              $scope.koForm = function () {
                vm.modalInfoLlegada.close();
                vm.lims_id = "";
              };
            }
          });
        }
      });
    }

    vm.parseCurrentPeticion = function(currentPeticion){
      var parsedPeticion = {
        id: currentPeticion?.id ?? '',
        centro_name: currentPeticion?.centro?.nombre ?? '',
        animal_name: currentPeticion?.animal?.nombre ?? '',
        animal_especie: currentPeticion?.animal?.especie?.nombre ?? '',
        tiposestados: currentPeticion?.tiposestados ?? []
      };
      console.log("peticionParseada", parsedPeticion);
      return parsedPeticion; 
    }

    vm.parsePeticionesCentro = function(peticiones){
      var peticionesCentro = [];
      peticiones.forEach(pet => {
        peticionesCentro.push(
          pet?.id,
        );
      });
      console.log("peticionesCentro", peticionesCentro);
      return peticionesCentro; 
    }

    vm.getMuestras = function (id) {
      vm.loading = true;
      vm.modalAcciones = "";
      PreanaliticaService.getPeticion((id ? id : vm.lims_id), function (data) {
        vm.loading = false;
        if (data.peticion) {
          if(vm.socketMaquinas){
            vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: data.peticionCurrent.id, currentPeticion: vm.parseCurrentPeticion(data.peticionCurrent), peticionesCentro: vm.parsePeticionesCentro(data.peticion) });
          }
          //MOSTRAMOS POPUP
          vm.modalPeticion = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-top',
            ariaDescribedBy: 'modal-body-top',
            templateUrl: 'peticion.html',
            size: 'full',
            backdrop: 'static',
            controller: function ($scope) {
              $timeout(function () {
                $('.trackinginp').focus();
              }, 1000);
              $scope.currentPeticion = data.peticionCurrent;
              $scope.generalLab = GenerallabService;
              console.log("CURRENT PETICION", $scope.currentPeticion);
              $scope.optionsEstadomuestra = vm.optionsEstadomuestra;
              $scope.optionsTipotubo = vm.optionsTipotubo;
              $scope.optionsTiposMuestra = vm.optionsTiposMuestra;
              $scope.peticion = data.peticion;
              $scope.tracking = "";
              $scope.loadingEstado = false;
              $scope.peticionCambiado = {};
              $scope.camaraTubos = false;
              $scope.cropsTubos = [];

              $scope.getAcciones = function (id) {
                ResultadosService.getAccionesByPet(id, function (data) {
                  $scope.generalLab.acciones = data.acciones;
                  vm.modalAcciones = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    templateUrl: 'accionespre.html',
                    size: 'lg',
                    //backdrop:'static',
                    controller: function ($scope) {
                      $scope.generalLab = GenerallabService;
                      $scope.koForm = function () {
                        vm.modalAcciones.close();
                      };
                    }
                  });
                });
              }

              $scope.abrirCamaraTubos = function () {
                var video = document.getElementById('video_tubos_muestras');

                var constraints = {
                  video: { facingMode: { exact: "environment" } },
                  audio: false
                };

                navigator.mediaDevices.getUserMedia(constraints)
                  .then(function (stream) {
                    video.srcObject = stream;
                    video.play();
                  })
                  .catch(function (err) {
                    console.warn("No se pudo abrir la cÃ¡mara trasera, intentando la frontal...", err);

                    // Fallback: abrir cÃ¡mara frontal si la trasera no estÃ¡ disponible
                    var fallbackConstraints = {
                      video: { facingMode: "user" },
                      audio: false
                    };

                    navigator.mediaDevices.getUserMedia(fallbackConstraints)
                      .then(function (stream) {
                        video.srcObject = stream;
                        video.play();
                      })
                      .catch(function (err2) {
                        console.error("No se pudo acceder a ninguna cÃ¡mara:", err2);
                      });
                  });
              }

              $scope.retomarFotoTubos = function () {
                $scope.cropsTubos = [];
                $scope.currentPeticion.tiposestados.forEach(function (tipo) {
                  tipo.imagenes = [];
                });
                //$scope.abrirCamaraTubos();
              }

              $scope.emitRefreshPeticion = function () {
                if(vm.socketMaquinas) {
                  vm.socketMaquinas.emit('preanalitica:refreshpeticion', { room: vm.timestamp, id: $scope.currentPeticion.id, currentPeticion: vm.parseCurrentPeticion($scope.currentPeticion) });
                }
              }

              $scope.refreshTipoMuestra = function (tipo) {
                PreanaliticaService.getTipoMuestra(tipo.tipomuestra_id, function (data) {
                  tipo.tipomuestra = data;
                  $scope.emitRefreshPeticion();
                })
              }

              $scope.refreshTipoTubo = function (tipo) {
                PreanaliticaService.getTipoTubo(tipo.tipotubo_id, function (data) {
                  tipo.tipotubo = data;
                  $scope.emitRefreshPeticion();
                })
              }

              if(vm.socketMaquinas){
                vm.socketMaquinas.off('preanalitica:foto-tubos');
                vm.socketMaquinas.on('preanalitica:foto-tubos', function (data) {
                  console.log('foto-tubos recibida', data);
                  $scope.sendFotoTubos(data);
                });

                vm.socketMaquinas.off('preanalitica:endpeticion');
                vm.socketMaquinas.on('preanalitica:endpeticion', function (data) {
                  console.log('endpeticion recibida', data);
                  if(data.save){
                    $timeout(function () {
                      $scope.cambiarPediente($scope.currentPeticion);
                    });
                  }else{
                    $scope.koForm();
                  }
                });

                vm.socketMaquinas.off('preanalitica:refreshpeticion');
                vm.socketMaquinas.on('preanalitica:refreshpeticion', function (data) {
                  console.log('refreshpeticion recibida', data);
                  $timeout(function () {
                    $scope.currentPeticion.tiposestados = data.currentPeticion.tiposestados;
                  });
                });

                vm.socketMaquinas.off('preanalitica:changepeticioncentro');
                vm.socketMaquinas.on('preanalitica:changepeticioncentro', function (data) {
                  console.log('changepeticioncentro recibida', data);
                  $timeout(function () {
                    if ($scope.peticion && $scope.peticion.length > 0) {
                      var found = $scope.peticion.find(function(p) { return p.id == data.id; });
                      if (found) {
                        $scope.currentPeticion = found;
                        vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: $scope.currentPeticion.id, currentPeticion: vm.parseCurrentPeticion($scope.currentPeticion) });
                      }
                    }
                  });
                });
              }

              $scope.sendFotoTubos = function (data) {
                console.log("datasendtubos", data);
                Upload.upload({
                  url: '/backend/preanalitica/subirfototubos',
                  data: { file: data, peticion_id: $scope.currentPeticion.id }
                  //data: { file: file, peticion_id: $scope.currentPeticion.id }
                }).then(function (resp) {
                  $scope.cropsTubos = resp.data.files;
                  var crop_count = $scope.cropsTubos.length;
                  console.log("CROP COUNT", crop_count, $scope.cropsTubos);

                  for (const tipo of $scope.currentPeticion.tiposestados) {
                    tipo.imagenes = [];
                  }
                  if (crop_count > 0) {
                    var index_crop = 0;

                    for (const tipo of $scope.currentPeticion.tiposestados) {
                      var cantidad_tipo = tipo.cantidad;
                      for (var i = 0; i < cantidad_tipo && index_crop < crop_count; i++) {
                        tipo.imagenes.push({
                          name: $scope.cropsTubos[index_crop].name,
                          src: $scope.cropsTubos[index_crop].src,
                          src_lab: $scope.cropsTubos[index_crop].src_lab,
                          id: $scope.cropsTubos[index_crop].id
                        });
                        index_crop++;
                      }
                    }

                  }

                  if(vm.socketMaquinas){
                    vm.socketMaquinas.emit('preanalitica:newtubos', {
                      room: vm.timestamp,
                      currentPeticion: vm.parseCurrentPeticion($scope.currentPeticion),
                      crops: $scope.cropsTubos
                    });
                  }
                  console.log('Response upload foto tubos: ', resp);

                }, function (resp) {
                  console.log('Error status: ' + resp.status, resp);
                }, function (evt) {
                  // progreso opcional
                });
              };


              $scope.hacerFotoTubos = function () {
                console.log("HACIENDO FOTO TUBOS...");
                var video = document.getElementById('video_tubos_muestras');
                var canvas = document.getElementById('canvas_tubos_muestras');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                canvas.getContext('2d').drawImage(video, 0, 0);
                var imageData = canvas.toDataURL('image/png');
                var file = new File([dataURItoBlob(imageData)], 'peticion_id_foto.png');
                $scope.sendFotoTubos();
              }

              $scope.getRange = function (n) {
                return new Array(parseInt(n) || 0);
              };

              $scope.borrarImagen = function (tipo, index, event) {
                if (event) event.stopPropagation();
                if (tipo.imagenes && tipo.imagenes[index]) {
                  tipo.imagenes[index] = null;
                }
              };

              $scope.abrirSelectorCrops = function (tipo, index) {
                console.log("abirendo selector crops", $scope.cropsTubos, tipo, index);
                if (!$scope.cropsTubos || $scope.cropsTubos.length === 0) {
                  alert("No hay crops disponibles. Escanea los tubos primero.");
                  return;
                }
                var modalInstance = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title',
                  ariaDescribedBy: 'modal-body',
                  templateUrl: 'selectorCrops.html',
                  size: 'lg',
                  controller: function ($scope, $uibModalInstance, crops) {
                    $scope.crops = crops;
                    $scope.seleccionar = function (crop) {
                      $uibModalInstance.close(crop);
                    };
                    $scope.cancelar = function () {
                      $uibModalInstance.dismiss('cancel');
                    };
                  },
                  resolve: {
                    crops: function () {
                      return $scope.cropsTubos;
                    }
                  }
                });

                modalInstance.result.then(function (selectedCrop) {
                  if (!tipo.imagenes) tipo.imagenes = [];
                  tipo.imagenes[index] = {
                    src: selectedCrop.src,
                    src_lab: selectedCrop.src_lab,
                    name: selectedCrop.name,
                    id: selectedCrop.id
                  };
                }, function () {
                  console.log("cancelled", tipo);
                  // Cancelled
                });
              };

              $scope.borrarTipo = function (peticion, index) {
                peticion.tiposestados.splice(index, 1);
                $scope.emitRefreshPeticion();
              };
              $scope.generarNuevo = function () {
                //console.log("nuevo");
                $scope.tracking = Date.now();
              };
              $scope.cambiarId = function (peticion) {
                $scope.currentPeticion = peticion;
                if(vm.socketMaquinas){
                  vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: $scope.currentPeticion.id, currentPeticion: vm.parseCurrentPeticion($scope.currentPeticion) });
                }
              };

              $scope.cambiarANO = function (index, pre, petin) {
                petin.preanalitica_lab.analiticasPueden.splice(index, 1);
                petin.preanalitica_lab.analiticasNoPueden.push(pre);
              }

              $scope.cambiarASI = function (index, pre, petin) {
                petin.preanalitica_lab.analiticasNoPueden.splice(index, 1);
                petin.preanalitica_lab.analiticasPueden.push(pre);
              }

              $scope.printCode = function (value) {
                /*var myImage = "data:image/png;base64,"+peticion.barcode;
                var myWindow = window.open("", "Image");
                myWindow.document.write("<div style='overflow:hidden'><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div></div>");
                myWindow.print();
                myWindow.close();
                //console.log("print");*/
                //window.print();
                vm.printRaw(value);
              };
              $scope.okForm = function () {
                vm.lims_id = "";
                vm.modalPeticion.close();
                //vm.socketMaquinas.emit('preanalitica:endpeticion', { room: vm.timestamp });
                //vm.abrirCamara();
                //$.pjax({container: '#pjax-grid-view',async:false})
                $.pjax.reload('#pjax-grid-view', { timeout: false });
              };
              $scope.koForm = function () {
                vm.lims_id = "";
                vm.modalPeticion.close();
                //vm.socketMaquinas.emit('preanalitica:endpeticion', { room: vm.timestamp });
                //vm.abrirCamara();
              };
              $scope.cambiarPediente = function (peticion) {
                $scope.loadingEstado = true;
                peticion.tracking = $scope.tracking;
                PreanaliticaService.cambiarPendiente(peticion, function (data) {
                  if (typeof (data.carta) != 'undefined' && data.carta.length > 0) {
                    //console.log("EMIT nueva carta");
                    for (var cont = 0; cont < data.carta.length; cont++) {
                      socket.emit('pizarra:nuevacarta', { carta: data.carta[cont] });
                    }
                  }
                  if (data.code != -1000) {
                    //$.pjax.reload('#pjax-grid-view', {timeout: 1000});
                    //vm.modalPeticion.close();

                    var res = false;
                    $scope.retomarFotoTubos();
                    ////console.log($scope.peticion);
                    ////console.log($scope.currentPeticion);
                    for (var cont = 0; cont < $scope.peticion.length && !res; cont++) {
                      if ($scope.peticion[cont].id == peticion.id) {
                        res = cont;
                      }
                    }
                    if (res >= 0) {
                      $scope.peticion.splice(res, 1);
                      if ($scope.peticion.length > 0) {
                        $scope.currentPeticion = $scope.peticion[0];
                        if(vm.socketMaquinas){
                          vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: $scope.currentPeticion.id, currentPeticion: vm.parseCurrentPeticion($scope.currentPeticion), peticionesCentro: vm.parsePeticionesCentro($scope.peticion) });
                        }
                      } else {
                        console.log("ABRIR CAMARA");
                        vm.modalPeticion.close();
                        //vm.socketMaquinas.emit('preanalitica:endpeticion', { room: vm.timestamp });
                        $.pjax.reload('#pjax-grid-view', { timeout: false });
                        ////vm.abrirCamara();
                      }
                    }

                    $scope.loadingEstado = false;
                    vm.lims_id = "";

                    var printObject = {
                      peticion_id: data.res.id,
                      lims_id: data.res.lims_id[0].value,
                      barcode: data.res.barcode,
                      print: data.print
                    };
                    if(vm.socketMaquinas){
                      vm.socketMaquinas.emit('preanalitica:openprint', { room: vm.timestamp, printObject: printObject });
                    }
                    vm.modalOK = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'modalok.html',
                      size: 'lg',
                      backdrop: 'static',
                      controller: function ($scope) {
                        console.log("OPEN MODAL IMPRIMIR", data.res, peticion, data.print);
                        $scope.peticionCambiado = data.res;
                        $scope.peticion = peticion;
                        $scope.printRaw = function () {
                          vm.printRaw(data.print);
                        }
                        $scope.koForm = function () {

                          vm.modalOK.close();
                        };
                      }
                    });
                    vm.printRaw(data.print);
                  } else {
                    alert("CODIGO REPETIDO, VUELVE A DARLE AL BOTÃ“N");
                    $scope.loadingEstado = false;
                  }
                });
              };
            }
          });
        } else {
          if(vm.socketMaquinas){
            vm.socketMaquinas.emit('preanalitica:newpeticion', { room: vm.timestamp, id: false, read_code: id });
          }
          //vm.abrirCamara();
        }
        //vm.grid = data.grid;
      });
      //$.pjax({container: '#pjax-grid-view'})
      //$("#pjax-grid-view").submit();
      //$.pjax.reload({container: '#pjax-grid-view'});
      //$.pjax.reload({container:'#pjax-grid-view'});
    };

    vm.motionDetectionInterval = null;
    vm.stillnessTimer = null;
    vm.isDetecting = false;
    vm.zoomLevel = 1;
    vm.zoomCapabilities = null;

    vm.zoomLevel = 1;
    vm.zoomCapabilities = null;

    vm.setZoom = function (level) {
      console.log("Intentando establecer zoom a:", level);
      var video = document.getElementById('video_peticion_id');
      if (video && video.srcObject) {
        const stream = video.srcObject;
        const track = stream.getVideoTracks()[0];
        if (vm.zoomCapabilities) {
          const newZoom = Math.max(vm.zoomCapabilities.min, Math.min(level, vm.zoomCapabilities.max));

          // Intenta aplicar el zoom usando la propiedad 'zoom' directamente
          track.applyConstraints({ zoom: newZoom })
            .then(() => {
              $timeout(function () {
                vm.zoomLevel = newZoom;
              });
              console.log("Zoom (directo) establecido en:", newZoom);
            })
            .catch((e1) => {
              console.warn("Fallo al aplicar zoom directo, intentando con 'advanced':", e1.name, e1.message);
              // Si falla, intenta con la propiedad 'advanced'
              track.applyConstraints({ advanced: [{ zoom: newZoom }] })
                .then(() => {
                  $timeout(function () {
                    vm.zoomLevel = newZoom;
                  });
                  console.log("Zoom ('advanced') establecido en:", newZoom);
                })
                .catch(e2 => console.error("Error al aplicar zoom con 'advanced':", e2.name, e2.message));
            });
        } else {
          console.warn("Las capacidades de zoom no estÃ¡n disponibles.");
        }
      }
    };


    vm.abrirCamara = function () {
      vm.stopMotionDetection(); // Detener cualquier instancia anterior

      var video = document.getElementById('video_peticion_id');

      // Eliminar el listener anterior si existe para evitar duplicados
      if (vm.videoLoadedHandler) {
        video.removeEventListener('loadeddata', vm.videoLoadedHandler);
      }

      // Definir el manejador del evento para poder referenciarlo
      vm.videoLoadedHandler = function () {
        const stream = video.srcObject;
        if (!stream) return;

        const track = stream.getVideoTracks()[0];
        const capabilities = track.getCapabilities();
        const settings = track.getSettings();

        if (capabilities.zoom) {
          $timeout(function () {
            vm.zoomCapabilities = capabilities.zoom;
            vm.zoomLevel = settings.zoom || capabilities.zoom.min;
            console.log("Zoom capabilities:", vm.zoomCapabilities);
            console.log("Current zoom:", vm.zoomLevel);
          });
        } else {
          console.warn("El dispositivo/navegador no reporta capacidades de zoom.");
        }

        $timeout(function () {
          vm.startMotionDetection(video);
        }, 100);
      };

      var constraints = {
        video: { facingMode: { exact: "environment" } },
        audio: false
      };

      navigator.mediaDevices.getUserMedia(constraints)
        .then(function (stream) {
          video.srcObject = stream;
          video.play();
          video.addEventListener('loadeddata', vm.videoLoadedHandler);
        })
        .catch(function (err) {
          console.warn("No se pudo abrir la cÃ¡mara trasera, intentando la frontal...", err);

          // Fallback: abrir cÃ¡mara frontal si la trasera no estÃ¡ disponible
          var fallbackConstraints = {
            video: { facingMode: "user" },
            audio: false
          };

          navigator.mediaDevices.getUserMedia(fallbackConstraints)
            .then(function (stream) {
              video.srcObject = stream;
              video.play();
              const track = stream.getVideoTracks()[0];
              const capabilities = track.getCapabilities();
              const settings = track.getSettings();

              if (capabilities.zoom) {
                vm.zoomCapabilities = capabilities.zoom;
                vm.zoomLevel = settings.zoom;
                console.log("Zoom capabilities:", vm.zoomCapabilities);
                console.log("Current zoom:", vm.zoomLevel);
              }
              // Usamos el mismo manejador para el fallback
              video.addEventListener('loadeddata', vm.videoLoadedHandler);
            })
            .catch(function (err2) {
              console.error("No se pudo acceder a ninguna cÃ¡mara:", err2);
            });
        });
    }

    vm.stopMotionDetection = function () {
      vm.initialMotionDetected = false; // Flag para detectar el primer movimiento

      if (vm.motionDetectionInterval) {
        clearInterval(vm.motionDetectionInterval);
        vm.motionDetectionInterval = null;
      }
      if (vm.stillnessTimer) {
        clearTimeout(vm.stillnessTimer);
        vm.stillnessTimer = null;
      }
      vm.isDetecting = false;
      console.log("DetecciÃ³n de movimiento detenida.");

      var video = document.getElementById('video_peticion_id');
      if (video) {
        // Eliminar el listener de 'loadeddata' para limpiar todo
        if (vm.videoLoadedHandler) {
          video.removeEventListener('loadeddata', vm.videoLoadedHandler);
          vm.videoLoadedHandler = null;
        }
        if (video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
          video.srcObject = null;
        }
      }
    };

    vm.startMotionDetection = function (video) {
      console.log("Iniciando detecciÃ³n de movimiento..." + Math.random());
      vm.isDetecting = true;
      var motionCanvas = document.createElement('canvas');
      var motionContext = motionCanvas.getContext('2d');
      var lastImageData;
      var stillnessDelay = 500; // 1.5 segundos de quietud antes de disparar la acciÃ³n

      // Reducir la resoluciÃ³n para mejorar el rendimiento
      motionCanvas.width = 64;
      motionCanvas.height = 48;
      vm.initialMotionDetected = false; // Flag para detectar el primer movimiento


      vm.motionDetectionInterval = setInterval(function () {
        if (!vm.isDetecting) return;

        motionContext.drawImage(video, 0, 0, motionCanvas.width, motionCanvas.height);
        var currentImageData = motionContext.getImageData(0, 0, motionCanvas.width, motionCanvas.height).data;

        if (lastImageData) {
          var diff = 0;
          for (var i = 0; i < currentImageData.length; i += 4) {
            diff += Math.abs(currentImageData[i] - lastImageData[i]);
          }

          var motionThreshold = 30000; // Ajusta este valor segÃºn la sensibilidad deseada

          if (diff > motionThreshold) {
            // Movimiento detectado
            //console.log("Movimiento detectado, reiniciando temporizador de quietud.");
            if (!vm.initialMotionDetected) {
              console.log("Primer movimiento detectado. Esperando quietud...");
              vm.initialMotionDetected = true;
            }
            if (vm.stillnessTimer) {
              clearTimeout(vm.stillnessTimer);
              vm.stillnessTimer = null;
            }
          } else if (vm.initialMotionDetected) {
            // No hay movimiento (o es insignificante)
            if (!vm.stillnessTimer) {
              //console.log("Posible quietud, iniciando temporizador...");
              vm.stillnessTimer = setTimeout(function () {
                //alert("El movimiento se ha detenido. Capturando imagen.");
                console.log("Objeto quieto. Tomando foto.");
                vm.hacerFoto();
                vm.stopMotionDetection(); // Detener todo despuÃ©s de la captura
              }, stillnessDelay);
            }
          }
        }
        lastImageData = currentImageData;
      }, 100); // Comprobar cada 300ms
    };

    vm.hacerFoto = function () {
      console.log("HACIENDO FOTO...");
      var video = document.getElementById('video_peticion_id');
      var canvas = document.getElementById('canvas_peticion_id');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      var imageData = canvas.toDataURL('image/png');
      var file = new File([dataURItoBlob(imageData)], 'peticion_id_foto.png');
      vm.sendFotoSobre(file, false);
    }

    function dataURItoBlob(dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    }
    //console.log("prean");

    vm.init();

  }

})();